var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[(_vm.getRejectItem.name !== 'default')?_c(_vm.getRejectItem.component,{tag:"component"}):_c('DefaultHandler',{attrs:{"message":_vm.rejectData.message}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }